export default __webpack_public_path__ + "static/media/pesquisa_cinza.5e0bdd88.svg";